// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oW2Q","colBig":"styles_colBig__2M9uj","colSmall":"styles_colSmall__2Ig-v"};